import React from 'react';
import { RELATION_COLORS, RELATION_DASH } from './familyTreeData';

const TreeEdge = ({ x1, y1, x2, y2, type, isHighlighted, isDimmed }) => {
  const color = RELATION_COLORS[type] ?? '#9CA3AF';
  const dash  = RELATION_DASH[type] ?? null;

  // Cousin edges get a wider arc to visually distinguish lateral bonds
  const arcOffset = type === 'cousin' ? 55 : 30;
  const midX = (x1 + x2) / 2;
  const midY = (y1 + y2) / 2 - arcOffset;
  const d    = `M${x1},${y1} Q${midX},${midY} ${x2},${y2}`;

  // Cousin edges use a slightly thicker glow so they stand out
  const glowWidth  = type === 'cousin' ? 8 : 6;
  const strokeWidth = isHighlighted ? (type === 'cousin' ? 3 : 2.5) : 1.5;

  return (
    <g opacity={isDimmed ? 0.1 : isHighlighted ? 1 : type === 'cousin' ? 0.55 : 0.45}>
      {/* Glow layer for highlighted edges */}
      {isHighlighted && (
        <path
          d={d} fill="none"
          stroke={color}
          strokeWidth={glowWidth}
          strokeLinecap="round"
          opacity={0.18}
        />
      )}

      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray={dash ?? undefined}
        strokeLinecap="round"
      />

      {/* Mid-point dot — larger for cousins */}
      <circle
        cx={midX} cy={midY + arcOffset * 0.5}
        r={type === 'cousin' ? 4 : 3}
        fill={color}
        opacity={isHighlighted ? 0.9 : 0.4}
      />

      {/* Cousin label badge at midpoint */}
      {type === 'cousin' && isHighlighted && (
        <g transform={`translate(${midX}, ${midY + arcOffset * 0.5 - 14})`}>
          <rect x={-22} y={-9} width={44} height={14} rx={7}
            fill={color} opacity={0.9} />
          <text textAnchor="middle" dominantBaseline="central"
            fontSize={7} fontWeight="900" fill="white" letterSpacing="0.05em">
            COUSIN
          </text>
        </g>
      )}
    </g>
  );
};

export default TreeEdge;